<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0"> Secretariat Instrument Status Report  </h5>
     <br/>
     <br>

     <div class="row">
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">Start Date</label>
        <input type="text" #datepickerInputStart placeholder="Type here..."   class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">End Date</label>
        <input type="text" #datepickerInputEnd  placeholder="Type here..."  class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">Customer Name </label>
        <input [(ngModel)]="Name" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">Title Instrument</label>
        <input [(ngModel)]="Code" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
    </div>

     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_DeviceInLetter(datepickerInputStart.value,datepickerInputEnd.value)"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
        style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Instrument Name</th>
              <th>Pro Forma Invoice</th>
              <th>Scheduled</th>
              <th>Received</th>
              <th>Certificate Review</th>
              <th>Approve Certificate</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceInLetter
            | paginate
                    : {
                        id: 'DataList_Customer',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_DeviceInLetter).length
                      }
            ">
              <td>{{DataList_DeviceInLetter.indexOf(item)+1}}</td>
              <td>{{item['title']}}</td>
              <td>{{item['preOrder']}}</td>
              <td>{{item['submitOrder']}}</td>
              <td>{{item['calibration']}}</td>
              <td>{{item['certificate']}}</td>
              <td>{{item['certificate_confirm']}}</td>
            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_Customer"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>


<table  id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>Instrument Name</th>
      <th>Pro Forma Invoice</th>
      <th>Scheduled</th>
      <th>Received</th>
      <th>Certificate Review</th>
      <th>Approve Certificate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_DeviceInLetter
    | paginate
            : {
                id: 'DataList_Customer',
                itemsPerPage: 50,
                currentPage: page,
                totalItems: (DataList_DeviceInLetter).length
              }
    ">
      <td>{{DataList_DeviceInLetter.indexOf(item)+1}}</td>
      <td>{{item['title']}}</td>
      <td>{{item['preOrder']}}</td>
      <td>{{item['submitOrder']}}</td>
      <td>{{item['calibration']}}</td>
      <td>{{item['certificate']}}</td>
      <td>{{item['certificate_confirm']}}</td>
    </tr>
  </tbody>
</table>